import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import PostsList from './PostsList';

// The Play component matches one of two different routes
// depending on the full pathname
class Play extends Component {
  componentDidMount() {
  }

  render() {
    return (
      <div className="main-index main-index--play">
        <Helmet>
          <title>Dan Ohlsen - Web Development, Design & Illustration</title>
        </Helmet>
        <div className="index-page-buffer" />
        <div className="grid-row grid-8">
          <div className="grid-cell grid-cell--no-padding">
            <p className="quote">
              <q className="quote__text">This is the real secret of life — to be completely engaged with what you are doing in the here and now. And instead of calling it work, realize it&nbsp;is&nbsp;play.</q>
              <span className="quote__author">Alan Watts</span>
            </p>

          </div>
        </div>
        <PostsList posts={this.props.posts} postType="Projects" loadData={this.props.loadData} />
      </div>
    );
  }
}

Play.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadData: PropTypes.func.isRequired,
};

export default Play;



// WEBPACK FOOTER //
// ./src/components/Play.js